import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import styled from '@emotion/styled'

import { ReactComponent as BackIcon } from '@doveconviene/sf-ui/icons/arrow_left.svg'

import {
  selectIsWebView, selectCountry, selectWebsiteURL, selectContext,
} from '../../../../flux/selectors/ux'
import Icon from '../../../ui/Icon'
import CookieConsent from '../../CookieConsent'

import { uxEvent } from '../../../../flux/actions/ux'

const StyledRoot = styled.div(({ theme }) => ({
  height: (theme.spaces.default / 2) * 6.5, // 52px
  borderBottom: `1px solid ${theme.colors.light_grey}`,
}))

const StyledContainer = styled.div(({ theme }) => ({
  padding: `0 ${theme.spaces.default}px`,
  maxWidth: theme.breakpoints.xlarge,
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
}))

const StyledBackButton = styled.div(({ theme }) => ({
  flex: '0 0 auto',
  paddingRight: theme.spaces.default,
}))

const StyledIcon = styled.div(({ theme }) => ({
  color: theme.colors.primary,
  cursor: 'pointer',
  height: '24px',
  width: '24px',
}))

const StyledImage = styled.img(({ theme }) => ({
  display: 'block',
  width: 'auto',
  height: 24,
  maxWidth: (theme.spaces.default / 2) * 19.5,
}))

const StyledLogoLink = styled.a({
  display: 'block',
})

const StyledLogo = styled.div(() => ({
  flex: '1 1 0',
}))

const BrandHeader = ({
  logoSrc,
  logoHref,
  isWebView,
  back,
  onLogoClick,
  onBackClick,
}) => (
  isWebView !== undefined && isWebView === false ? (
    <StyledRoot data-test="BrandHeader">
      <StyledContainer>
        {back ? (
          <StyledBackButton data-test="BrandHeaderBack" onClick={onBackClick}>
            <StyledIcon>
              <Icon>
                <BackIcon />
              </Icon>
            </StyledIcon>
          </StyledBackButton>
        ) : null}
        <StyledLogo>
          <StyledLogoLink href={logoHref}>
            <StyledImage data-fallback="true" data-test="BrandHeaderLogo" src={logoSrc} onClick={onLogoClick} />
          </StyledLogoLink>
        </StyledLogo>
        <CookieConsent />
      </StyledContainer>
    </StyledRoot>
  ) : <CookieConsent />
)

BrandHeader.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  logoHref: PropTypes.string,
  isWebView: PropTypes.bool,
  back: PropTypes.string, // Pathname to go back to
  onLogoClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
}

BrandHeader.defaultProps = {
  back: '',
  logoHref: null,
  isWebView: undefined,
}

const mapStateToProps = state => {
  const country = selectCountry(state)?.toLowerCase()
  const context = selectContext(state)
  const fileName = context === 'dvc' ? country : 'global'
  const logoSrc = `${process.env.PUBLIC_URL}/img/brand/${context}/${fileName}.svg`

  return {
    logoSrc,
    isWebView: selectIsWebView(state),
    country: selectCountry(state),
    logoHref: selectWebsiteURL(state),
  }
}

const mapDispatchToProps = {
  uxEvent,
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onLogoClick: () => {
    dispatchProps.uxEvent({
      name: 'click',
      target: 'BrandHeader/Logo',
      params: {},
    })
  },
  onBackClick: () => {
    dispatchProps.uxEvent({
      name: 'click',
      target: 'BrandHeader/Back',
      params: {
        pathname: ownProps.back,
      },
    })
  },
})

BrandHeader.displayName = 'BrandHeader'
BrandHeader.whyDidYouRender = true

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  BrandHeader,
)
